/**
 * TenantNotFoundPage — 존재하지 않는 테넌트 subdomain 접근 시 렌더링
 * Platform으로 돌아가거나 문의할 수 있는 명확한 안내 제공.
 */
import React from 'react';
import { buildPlatformUrl } from '@shared/tenant-host';

interface TenantNotFoundPageProps {
  tenantId: string;
  tenantRootDomain: string | null;
}

export const TenantNotFoundPage: React.FC<TenantNotFoundPageProps> = ({
  tenantId,
  tenantRootDomain,
}) => {
  const platformUrl = tenantRootDomain ? buildPlatformUrl(tenantRootDomain, '/') : '/';

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        gap: 'var(--space-4)',
        textAlign: 'center',
        padding: 'var(--space-8)',
      }}
    >
      <div style={{ fontSize: '3rem', opacity: 0.3 }}>404</div>
      <h1 style={{ fontSize: '1.25rem', fontWeight: 600 }}>조직을 찾을 수 없습니다</h1>
      <p style={{ color: 'var(--color-text-secondary)', maxWidth: 360 }}>
        <strong>{tenantId}</strong> 조직이 존재하지 않거나 접근할 수 없습니다. 조직 주소를
        확인하거나 플랫폼으로 돌아가세요.
      </p>
      <a
        href={platformUrl}
        style={{
          marginTop: 'var(--space-2)',
          color: 'var(--color-text-info)',
          textDecoration: 'none',
          fontSize: '0.9rem',
        }}
      >
        ← 플랫폼으로 돌아가기
      </a>
    </div>
  );
};

export default TenantNotFoundPage;
